import {booleanAttribute, Component, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoPageHeaderComponent} from '../../shared/components/info-page-header/info-page-header.component';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {PaymentsService} from '../../core/api/payments.service';
import {CheckinSummary, PaymentCheckIns} from '../../shared/models/payment-check-ins.model';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {environment} from '../../../environments/environment';
import {ModalInfoService} from '../../core/services/modal-info.service';
import {MetricsService} from '../../core/services/metrics.service';
import {ModalErrorService} from '../../core/services/modal-error.service';

@Component({
  selector: 'app-deposit-select-check-in',
  templateUrl: './deposit-select-check-in.component.html',
  styleUrls: ['./deposit-select-check-in.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InfoPageHeaderComponent],
  standalone: true
})
export class DepositSelectCheckInComponent implements OnInit {

  form: FormGroup;
  checkins: CheckinSummary[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private paymentService: PaymentsService,
    private metricsService: MetricsService,
    private modalInfoService: ModalInfoService,
    private modalErrorService: ModalErrorService,
    private hoomvipStorage: HoomvipStorage,
  ) {
    this.form = this.fb.group({
      checkin: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadPaymentCheckins();
  }

  loadPaymentCheckins(): void {
    this.paymentService.getPaymentCheckins().subscribe({
      next: (data: PaymentCheckIns) => {
        this.checkins = data.checkins;
      },
      error: (error) => {
        console.error('Error al cargar los checkins:', error);
      }
    });
  }
  getFullName(checkin: CheckinSummary): string {
    return `${checkin.NAME} ${checkin.SURNAME}`.trim();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const selectedCheckinId = this.form.get('checkin')?.value;
    this.paymentService.getPaymentForm(selectedCheckinId).subscribe({
      next: (response: string) => {
        if (this.depositInProcess(response)) {
          this.metricsService.depositInProcess();
          this.modalInfoService.enqueue(
            'Posible pago en proceso de validación',
            ['Por favor, comprueba si necesitas validar el pago en la app de tu banco.'
            ],
          )
          this.router.navigate(['/']);
          return;
        }
        this.router.navigate(['/deposit', selectedCheckinId]);
      },
      error: (error) => {
        if (error.status === 422) {
          const messages = this.modalErrorService.extractAllErrors(error);
          this.modalErrorService.enqueue(
            'Error al obtener el formulario de pago',
            messages.length > 0 ? messages : ['No ha sido posible obtener el formulario de pago']
          );
        }
        console.error('Error al obtener el formulario de pago:', error);
        this.router.navigate(['/']);
      }
    });
  }

  depositInProcess(response: string): boolean {
    return typeof response === 'string' && response.trim().toLowerCase() === 'false';
  }
}
